import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import { FormControl, TextField } from '@material-ui/core';
import { post } from '../../Services/http';
import StyledSelect from '../StyledSelect';
import LoadingDots from '../LoadingDots';
import LoginModalChangePasswordForm from './LoginModal.ChangePasswordForm';
import { getUrlQueryParameter } from '../../Services/utils';

const LoginModalLoginForm = ({
  onError,
  onForgotPasswordClick,
  email,
  registerUserLink,
  loginOverlayText,
  onEmailChanged,
  setDisableClosing,
}) => {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOrganizationId, setSelectedOrganizationId] = useState();
  const [organizations, setOrganizations] = useState();
  const [showChangePassword, setShowChangePassword] = useState(false);

  const performLogin = () => {
    setIsLoading(true);
    post('/api/login', {
      email,
      password,
      redirectUrl: getUrlQueryParameter('loginRedirectUrl'),
    })
      .then((res) => res.json())
      .then(handleLoginResponse)
      .catch((err) => {
        err.response.json().then((data) => onError(data.error));
        setIsLoading(false);
      });
  };

  const handleSuccessfulLogin = (data) => {
    const redirectUrl = getUrlQueryParameter('loginRedirectUrl');
    if (redirectUrl) {
      location.href = redirectUrl;
    } else {
      location.reload();
    }
  };

  const selectOrganization = () => {
    setIsLoading(true);
    post(`/api/login/organizations/${selectedOrganizationId}`, {})
      .then((res) => res.json())
      .then((data) => {
        onError(data.error);

        if (data.success) {
          handleSuccessfulLogin(data);
        } else {
          setIsLoading(false);
        }
      })
      .catch((err) => {
        err.response.json().then((data) => onError(data.error));
        setIsLoading(false);
      });
  };

  const handleLoginResponse = (data) => {
    onError(data.error);

    if (data.success) {
      if (data.requestToken) {
        localStorage.setItem('requestVerificationToken', data.requestToken);
      }

      setShowChangePassword(data.mustChangePassword);

      if (!data.organizations && !data.mustChangePassword) {
        handleSuccessfulLogin(data);
      } else {
        setOrganizations(data.organizations);
        setDisableClosing(true);
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  return (
    <>
      {!showChangePassword && (
        <>
          {!organizations && (
            <>
              <h3>{translate('general.login')}</h3>
              {loginOverlayText && (
                <p className="login-modal__login-text">{loginOverlayText}</p>
              )}
              <FormControl>
                <label htmlFor="email">{translate('general.email')}</label>
                <TextField
                  variant="outlined"
                  id="email"
                  value={email}
                  onChange={(e) => onEmailChanged(e.target.value)}
                  onKeyDown={(e) => e.key == 'Enter' && performLogin()}
                  placeholder={translate('general.enter-email')}
                  disabled={isLoading}
                  autoFocus={true}
                />
              </FormControl>
              <FormControl>
                <label htmlFor="password">
                  {translate('general.password')}
                </label>
                <TextField
                  variant="outlined"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => e.key == 'Enter' && performLogin()}
                  placeholder={translate('general.enter-password')}
                  type="password"
                  disabled={isLoading}
                />
              </FormControl>
            </>
          )}
          {organizations && (
            <>
              <h3>{translate('login.choose-organization')}</h3>
              <StyledSelect
                onChange={({ value }) => setSelectedOrganizationId(value)}
                options={Object.keys(organizations).map((systemId) => ({
                  value: systemId,
                  label: organizations[systemId],
                }))}
                isDisabled={isLoading}
              />
              <button
                className="btn btn--black"
                onClick={selectOrganization}
                disabled={isLoading || !selectedOrganizationId}
              >
                {!isLoading && translate('general.select')}
                {isLoading && <LoadingDots size="small" color="white" />}
              </button>
            </>
          )}
          {!organizations && (
            <>
              <button
                className="btn btn--black"
                onClick={performLogin}
                disabled={isLoading}
              >
                {!isLoading && translate('general.login')}
                {isLoading && <LoadingDots size="small" color="white" />}
              </button>
              <div className="login-modal__divider"></div>
              <a
                onClick={() => !isLoading && onForgotPasswordClick()}
                className="login-modal__forgot-password-link"
              >
                {translate('login.forgot-password')}
              </a>
            </>
          )}
        </>
      )}
      {showChangePassword && (
        <LoginModalChangePasswordForm
          email={email}
          oldPassword={password}
          onPasswordChanged={handleLoginResponse}
          onError={onError}
        />
      )}
    </>
  );
};

export default LoginModalLoginForm;
